angular.module('TeacherControllers')

  .filter('planCurrent', [function() {
    return function(current) {
      var str = {
        "-1": "passé",
        "0": "en cours de réalisation",
        "1": "à venir"
      };

      return (str[current]);

    };

  }]);
